import { createContext, useState } from "react";

export const RegistrationContext = createContext();

export const RegistrationContextProvider = ({ children }) => {
    // Basic Information
    const [basicEmail, setBasicEmail] = useState('');
    const [isVerifyEmailOpen, setIsVerifyEmailOpen] = useState(false);

    // Business info
    const defaultGSTDetails = {
        gstIn: '',
        ownerName: '',
        ownerEmail: '',
        email: '',
    };

    const defaultGSTDetailsError = {
        gstIn: '',
        ownerName: '',
        ownerEmail: '',
    };

    const defaultGSTInfo = {
        legalname: '',
        panNumber: '',
        address: '',
        addressTotal: {},
    };

    const [gstCardInfo, setGstCardInfo] = useState(defaultGSTInfo);
    const [gstVerified, setGstVerified] = useState(false);
    const [isSameEmail, setIsSameEmail] = useState(false);
    const [fetchedEmail, setFetchedEmail] = useState('');
    const [gstDetails, setGstDetails] = useState(defaultGSTDetails);
    const [gstDetailsError, setGstDetailsError] = useState(defaultGSTDetailsError);

    // Store Setup
    const defaultStoreDetails = {
        storeName: '',
        storeAddress: '',
        storePincode: '',
        storeCity: '',
        storeState: '',
        storeCountry: 'India',
        description: '',
    };

    const defaultStoreDetailsErrors = {
        storeName: '',
        storeCategory: '',
        targetAudience: '',
        description: '',
        storePincode: '',
        storeAddress: '',
        storeCity: '',
        storeState: '',
        pincode: '',
        Addr: '',
        city: '',
        state: '',
        warehouseMarker: '',
    };

    const defaultWarehouseAddress = {
        pincode: '',
        Addr: '',
        city: '',
        state: '',
        country: 'India',
    };

    const [markerPositionWarehouse, setMarkerPositionWarehouse] = useState(null);

    const [storeDetails, setStoreDetails] = useState(defaultStoreDetails);
    const [storeErrors, setStoreErrors] = useState(defaultStoreDetailsErrors);
    const [optionalAddress, setOptionalAddress] = useState('');
    const [optionalWarehouseAddress, setOptionalWarehouseAddress] = useState('');
    const [storeCategory, setStoreCategory] = useState([]);
    const [targetAudience, setTargetAudience] = useState([]);
    const [warehouseAddress, setWarehouseAddress] = useState(defaultWarehouseAddress);
    const [isWarehouseAddressSame, setIsWarehouseAddressSame] = useState(false);

    // Bank Details
    const defaultBankDetails = {
        accountHolderName: '',
        accountNumber: '',
        confirmAccountNumber: '',
        ifscCode: '',
        cancelledChequeUrl: ''
    };

    const defaultBankErrors = {
        accountHolderName: '',
        accountNumber: '',
        confirmAccountNumber: '',
        ifscCode: '',
        cancelledChequeUrl: ''
    };

    const [bankDetails, setBankDetails] = useState(defaultBankDetails);
    const [bankErrors, setBankErrors] = useState(defaultBankErrors);

    const [signatureType, setSignatureType] = useState('');
    const [signatureFile, setSignatureFile] = useState({});
    const [chequeFile, setChequeFile] = useState({});
    const [loading, setLoading] = useState(false);

    // Optional helper to set both markers at once
    const setWarehouseMarker = (coords) => setMarkerPositionWarehouse(coords);

    const contextValue = {
        // Business info
        gstDetails,
        setGstDetails,
        gstVerified,
        setGstVerified,
        gstCardInfo,
        setGstCardInfo,
        isSameEmail,
        setIsSameEmail,
        fetchedEmail,
        setFetchedEmail,
        gstDetailsError,
        setGstDetailsError,
        defaultGSTDetailsError,

        // Store Setup
        storeDetails,
        setStoreDetails,
        storeCategory,
        setStoreCategory,
        targetAudience,
        setTargetAudience,
        warehouseAddress,
        setWarehouseAddress,
        isWarehouseAddressSame,
        setIsWarehouseAddressSame,
        optionalAddress,
        setOptionalAddress,
        storeErrors,
        setStoreErrors,
        defaultStoreDetailsErrors,
        optionalWarehouseAddress,
        setOptionalWarehouseAddress,

        // Bank Details
        bankDetails,
        setBankDetails,
        bankErrors,
        setBankErrors,
        defaultBankErrors,
        signatureType,
        setSignatureType,
        signatureFile,
        setSignatureFile,
        chequeFile,
        setChequeFile,

        loading,
        setLoading,

        markerPositionWarehouse,
        setMarkerPositionWarehouse: setWarehouseMarker,

        basicEmail,
        setBasicEmail,
        isVerifyEmailOpen,
        setIsVerifyEmailOpen,
    };

    return (
        <RegistrationContext.Provider value={ contextValue }>
            { children }
        </RegistrationContext.Provider>
    );
};
